import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n-lite';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import * as classroomGroupActions from '../../actions/classroom/classroomGroupActions';
import { getUrlFromTabView } from '../../utils/routeUtils';
import { GROUPS, ROUTES } from '../../const';
import { bindActionCreators } from 'redux';
import { isElectronApp } from '../../services/crossPlatform/crossPlatformService';
import CustomIcon from './CustomIcon';

import { ScrollToTop } from '@netexknowledge/smart-components';

let styles = {
  indicator: {
    color: 'black',
    backgroundColor: 'black'
  }
};

class SwipeableTabsContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      index: 0
    };
  }

  static propTypes = {
    selectedTabIndex: PropTypes.number,
    setActiveTab: PropTypes.func,
    tabsConstants: PropTypes.object,
    views: PropTypes.array,
    renderFab: PropTypes.bool,
    user: PropTypes.object,
    classes: PropTypes.object,
    handleFloatingButtonClick: PropTypes.func,
    wrapperClassName: PropTypes.string,
    connectionStatus: PropTypes.object,
    activeParticipantsClassroomTab: PropTypes.string
  };

  static defaultProps = {
    selectedTabIndex: 0
  };

  componentDidMount() {
    this.setState({
      index: this.props.selectedTabIndex
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { selectedTabIndex } = this.props;
    if (prevProps.selectedTabIndex !== selectedTabIndex && selectedTabIndex >= 0 && selectedTabIndex !== this.state.index) {
      this.setState({ index: selectedTabIndex });
    }

    const { index } = this.state;
    const { setActiveTab, tabsConstants, activeParticipantsClassroomTab } = this.props;

    const tabKeys = Object.keys(tabsConstants);
    const activeTab = tabKeys[index];
    if (setActiveTab && activeTab && tabsConstants[activeTab] && activeTab !== activeParticipantsClassroomTab) {
      setActiveTab(tabsConstants[activeTab].key);
    }
  }

  setPathUrl = (views, index) => {
    const path = this.getPathNameFromView(views[index]);
    if (path && !isElectronApp()) window.history.pushState(null, '', path);
  };

  calculateSlideHeight = () => {
    const { connectionStatus } = this.props;
    let className = 'slide-height-l';
    if (!this.shouldHideTabsRow()) {
      className = 'slide-height-m';
    }
    if (!connectionStatus.general || !connectionStatus.rabbit) {
      className = 'slide-height-s';
    }
    return className;
  };

  getPathNameFromView(view) {
    return getUrlFromTabView(view, this.props.selectedClassroomId);
  }

  handleTabChange = (event, value) => {
    this.setState({ index: value }, () => {
      this.props.classroomGroupActions.setSelectedGroup(GROUPS.EVERYONE);
      this.setPathUrl(this.props.views, value);
    });
  };

  handleSwipeTab = index => {
    this.props.classroomGroupActions.setSelectedGroup(GROUPS.EVERYONE);
    this.setState({ index });
  };

  shouldHideTabsRow() {
    const { tabsConstants } = this.props;
    return Object.keys(tabsConstants).length < 2;
  }

  renderTabs() {
    const { index } = this.state;
    const { tabsConstants, classes, group, selectedClassroomId, colors } = this.props;

    const studentsRoute = new RegExp(ROUTES.REGEXP.CLASSROOM_STUDENTS);
    const inGroup = studentsRoute.test(window.location.pathname) && group.id !== GROUPS.EVERYONE.id;

    if (this.shouldHideTabsRow()) {
      return null;
    }

    const tabs = Object.keys(tabsConstants).map(key => {
      const tab = tabsConstants[key];

      return (
        <Tab
          style={{ fontFamily: 'Lato, DefaultLato sans-serif' }}
          label={<Translate value={tab.label} className="tabs-label" />}
          key={tab.key}
          disabled={tab.disabledTab}
          icon={tab.icon ? <CustomIcon name={tab.icon} size={16} classes={'tabs-icon'} /> : null}
        />
      );
    });

    if (!inGroup) {
      const tabStyle = {
        backgroundColor: selectedClassroomId ? colors.backgroundPrimary : colors.primary,
        transition: 'background-color 1s ease-in-out, color 1s ease-in-out, max-height 1s ease-in-out',
        fontColors: selectedClassroomId ? undefined : 'white',
        color: selectedClassroomId ? undefined : 'white'
      };

      return (
        <Tabs
          TabIndicatorProps={{ style: { backgroundColor: selectedClassroomId ? undefined : 'white' } }}
          className="tabs-box-shadow"
          classes={classes}
          style={tabStyle}
          value={index}
          onChange={this.handleTabChange}
        >
          {tabs}
        </Tabs>
      );
    } else {
      return;
    }
  }

  renderSwipeableViews() {
    const { views } = this.props;
    const { index } = this.state;
    return (
      <SwipeableViews
        slideClassName={this.calculateSlideHeight()}
        index={index}
        className="swipeable-view-wrapper"
        onChangeIndex={this.handleSwipeTab}
      >
        {views.map((view, i) => {
          return view && index === i ? view : <Fragment key={i} />;
        })}
      </SwipeableViews>
    );
  }

  render() {
    const { wrapperClassName } = this.props;

    return (
      <div className={wrapperClassName ? wrapperClassName : 'tabs-wrapper'}>
        {this.renderTabs()}
        {this.renderSwipeableViews()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    layoutSettings: state.theme.layoutSettings,
    connectionStatus: state.connection.status,
    configuration: state.account.configuration,
    group: state.selectedGroup.group,
    user: state.account.user,
    selectedClassroomId: state.classrooms.selectedClassroom.classroom.id,
    activeParticipantsClassroomTab: state.classrooms.selectedClassroom.activeClassroomTab,
    colors: state.theme.colors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomGroupActions: bindActionCreators(classroomGroupActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(SwipeableTabsContainer));
